import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { toast } from 'sonner';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // In a real app, this would send to backend
    setTimeout(() => {
      toast.success('Thank you! We will get back to you within 24 hours.');
      setForm({ name: '', email: '', phone: '', message: '' });
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="section">
      <div className="container-grid">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-[-0.02em]">Contact Us</h1>
          <p className="text-muted-foreground mt-3">We're here to help. Reach out to us today.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Send us a message</CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="name">Name</Label>
                  <Input id="name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required data-testid="contact-name" />
                </div>
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required data-testid="contact-email" />
                </div>
                <div>
                  <Label htmlFor="phone">Phone</Label>
                  <Input id="phone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} data-testid="contact-phone" />
                </div>
                <div>
                  <Label htmlFor="message">Message</Label>
                  <Textarea id="message" rows={4} value={form.message} onChange={e => setForm({...form, message: e.target.value})} required data-testid="contact-message" />
                </div>
                <Button type="submit" className="w-full" disabled={loading} data-testid="contact-submit">
                  {loading ? 'Sending...' : 'Send Message'}
                </Button>
              </form>
            </CardContent>
          </Card>

          <div className="space-y-6">
            <Card>
              <CardContent className="p-6">
                <div className="space-y-4">
                  {[
                    { icon: Mail, label: 'Email', value: 'info@cataskflow.com' },
                    { icon: Phone, label: 'Phone', value: '+91-9999999999' },
                    { icon: MapPin, label: 'Address', value: 'Mumbai, Maharashtra, India' },
                    { icon: Clock, label: 'Working Hours', value: 'Mon - Sat: 9 AM - 7 PM' },
                  ].map(item => (
                    <div key={item.label} className="flex items-start gap-3">
                      <div className="h-10 w-10 rounded-lg bg-accent flex items-center justify-center flex-shrink-0">
                        <item.icon className="h-5 w-5 text-[hsl(156,38%,32%)]" />
                      </div>
                      <div>
                        <p className="font-medium text-sm">{item.label}</p>
                        <p className="text-sm text-muted-foreground">{item.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            <Card className="bg-accent/50">
              <CardContent className="p-6 text-center">
                <h3 className="font-semibold mb-2">24-Hour Response Guarantee</h3>
                <p className="text-sm text-muted-foreground">We commit to responding to all queries within 24 hours during business days.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
